import React from "react";

/**
 * כותרת סקשן + תוכן — קצב כמו .fw-review-card__head / גוף.
 */
export default function FWSection({
  title,
  lead,
  children,
  className = "",
  hidden = false,
  ...rest
}) {
  if (hidden) return null;
  return (
    <section
      className={`fw-ui-kit-section${className ? ` ${className}` : ""}`.trim()}
      {...rest}
    >
      {title ? (
        <div className="fw-ui-kit-section__head">
          <h2 className="fw-ui-kit-section__title">{title}</h2>
        </div>
      ) : null}
      {lead ? (
        <p className="fw-ui-results-hint" style={{ margin: "0 0 0.5rem" }}>
          {lead}
        </p>
      ) : null}
      <div className="fw-ui-kit-section__body">{children}</div>
    </section>
  );
}
